// extracted by mini-css-extract-plugin
module.exports = {"desktopNavWrapper":"Navigation_desktopNavWrapper__5rzCn"};